export default __webpack_public_path__ + "static/media/608.6fbeedb7.gif";